export const themeConstants = {
    HEADER: 'header',
    SIDEBAR: 'sidebar',
    FOOTER: 'footer',    
    LOGINPAGE: 'loginpage',
}
